module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBoldItalic.1e03d46.woff2";